import { render, staticRenderFns } from "./platformDictList.vue?vue&type=template&id=6ca7132c&scoped=true"
import script from "./platformDictList.vue?vue&type=script&lang=js"
export * from "./platformDictList.vue?vue&type=script&lang=js"
import style0 from "./platformDictList.vue?vue&type=style&index=0&id=6ca7132c&prod&lang=less&scoped=true"
import style1 from "./platformDictList.vue?vue&type=style&index=1&id=6ca7132c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca7132c",
  null
  
)

export default component.exports